import { render, staticRenderFns } from "./ChatPublicationMessage.vue?vue&type=template&id=7ac26b82&scoped=true&lang=pug&"
import script from "./ChatPublicationMessage.vue?vue&type=script&lang=js&"
export * from "./ChatPublicationMessage.vue?vue&type=script&lang=js&"
import style0 from "./ChatPublicationMessage.vue?vue&type=style&index=0&id=7ac26b82&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac26b82",
  null
  
)

export default component.exports